
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont les effets secondaires?`}</em></p>
    <p>{`Les résultats des essais cliniques n'ont pas encore été publiés. Pour les
vaccins qui ont déjà obtenu une autorisation, on dispose de plus d’informations
et de l’expérience du terrain. Après leur commercialisation, les produits
continuent en effet de faire l’objet d’un
`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/covid-19-vaccines-safety-update.html"
      }}>{`suivi`}</a>{`
rapproché et d’éventuels effets secondaires doivent être signalés.`}</p>
    <p>{`De manière
`}<a parentName="p" {...{
        "href": "https://ofsp-coronavirus.ch/vaccination/effets-secondaires-et-questions/"
      }}>{`générale`}</a>{`,
on a surtout annoncé en Suisse des réactions au site d’injection (notamment des
rougeurs), des douleurs musculaires ou articulaires, des frissons, des maux de
tête, de la fièvre… De telles réactions sont fréquentes lors d’un vaccin. Ces
effets secondaires surviennent plus souvent avec les deux vaccins à ARNm
utilisés actuellement (Moderna et Pfizer/BioNTech) qu’avec celui contre la
grippe saisonnière. Ce phénomène serait lié au fait que ces produits génèrent
une réponse immunitaire élevée.`}</p>
    <p>{`Des
`}<a parentName="p" {...{
        "href": "https://www.infovac.ch/docs/public/coronavirus/ssai-recommandations-pour-vaccins-contre-covid-19-en-cas-d-allergies-v8-2-f.pdf"
      }}>{`allergies graves`}</a>{`
ont été signalées après l’injection des vaccins à ARNm de Moderna et de Pfizer.
Elles sont spectaculaires, mais très rares, et peuvent être traitées.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;